import Axios from 'axios';
import {getHeaders} from '../../utills';
import ActiveAndPastJobDetailsActions from '../Actions/ActiveAndPastJobDetailsActions';
import ActiveJobsAction from '../Actions/ActiveJobsAction';
import AlertAction from '../Actions/AlertActions';
import AuthAction from '../Actions/AuthActions';
import GeneralAction from '../Actions/GeneralAction';
import Apis from '../Apis';

class ActiveJobsMiddleware {
  static getActiveJobs = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.next_page_url == undefined) {
            dispatch(ActiveJobsAction.ClearActiveJobsList());
          }
          let formdata = new FormData();
          formdata.append('status', userData?.Status);
          const {data} = await Axios.post(
            Apis.jobs(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(ActiveJobsAction.getActiveJobsList(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
  static getCompletedJobs = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.next_page_url == undefined) {
            dispatch(ActiveJobsAction.ClearCompletedJobsList());
          }
          let formdata = new FormData();
          formdata.append('status', userData?.Status);
          const {data} = await Axios.post(
            Apis.jobs(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(ActiveJobsAction.getCompletedJobsList(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static getActiveAndPastJobDetails = id => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const {data} = await Axios.get(
            Apis.jobDetail + `${id}`,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(
              ActiveAndPastJobDetailsActions.getActiveAndPastJobDetails(data),
            );
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static JobDetailsTaskSummary = id => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const {data} = await Axios.get(
            Apis.jobDetail + `${id}`,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static JobDetailsInventory = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('job_id',userData?.Job_id);
          for (const [i, item] of userData?.data?.entries()) {
            formdata.append(
              `inventories[${i}][task_inventory_id]`,
              item.task_inventory_id,
            );
            formdata.append(
              `inventories[${i}][quantity_used]`,
              item.quantity_used,
            );
          }
          const {data} = await Axios.post(
            Apis.updateInventoryStatus,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
}

export default ActiveJobsMiddleware;
